import { CommonButton } from '@Components/common/Button';
import styled from 'styled-components';
import { mq } from 'stylesheets/utils';

export const Div = styled.div`
  width: 100%;
  min-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${mq(576)} {
    padding-top: 60px;
    min-height: calc(100vh - 60px); /* 60px for fixed navbar height in mobile */
  }
`;

export const LogoWrapper = styled.div`
  max-width: 400px;
  height: 80px;
  padding: 0 12px;
`;

export const ErrorMessage = styled.h4`
  font-size: ${({ theme }) => theme.fontsizes.h4};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  margin-bottom: 10px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${mq(576)} {
    flex-direction: column;
  }
`;

export const ErrorCta = styled(CommonButton)`
  margin: 0 6px;
  ${mq(576)} {
    margin-bottom: 12px;
  }
`;
